'use strict';

(function ($, Drupal, once) {
  Drupal.behaviors.CarouselMain = {
    attach: function attach(context, settings) {
      console.log('CarouselMain behavior attached');
      var $carousel = once('carousel-main-init', '.carousel-full-width', context);
      if ($carousel.length) {
        var carousel = function carousel() {
          console.log('Carousel function executed');
          var countSlide = 0;
          $('.carousel-full-width .quoteblock img.media__element', context).each(function (i, k) {
            var srcimage = $(k).attr('data-src') || $(k).attr('src');
            if (srcimage) {
              $('.carousel-full-width .images', context).append("<picture class=\"image\"><img src=\"".concat(srcimage, "\" ></picture>"));
              $('.carousel-full-width .next-image-wrapper', context).append("<picture class=\"image\"><img src=\"".concat(srcimage, "\" ></picture>"));
              countSlide += 1;
            } else {
              console.log('No image found for quoteblock index:', i);
            }
          });
          if (countSlide < 2) {
            $('.carousel-full-width .testimonial-carousel .testimonial-wrapper .info-area .controls', context).hide();
          }
          $('.carousel-full-width .images picture:nth-child(1)', context).addClass('active');
          $('.carousel-full-width .next-image-wrapper picture:nth-child(2)', context).addClass('active');
          $('.carousel-full-width .quoteblock:nth-child(1)', context).addClass('active');
          var carousalCount = 1;
          var carousalNextCount = 2;
          var carousalTotalCount = $('.carousel-full-width .quoteblock', context).length;
          function prevCarousel() {
            if (carousalCount > 1) {
              updateCarousel(--carousalCount, --carousalNextCount);
            } else {
              carousalCount = carousalTotalCount;
              carousalNextCount = 1;
              updateCarousel(carousalCount, carousalNextCount);
            }
          }
          function nextCarousel() {
            if (carousalCount < carousalTotalCount) {
              updateCarousel(++carousalCount, carousalCount === carousalTotalCount ? 1 : ++carousalNextCount);
            } else {
              carousalCount = 1;
              carousalNextCount = 2;
              updateCarousel(carousalCount, carousalNextCount);
            }
          }
          function updateCarousel(curr, next) {
            $('.carousel-full-width .detail .quoteblock.active, .image-area .images .image.active, .next-image-wrapper .image.active', context).removeClass('active');
            $(".carousel-full-width .detail .quoteblock:nth-child(".concat(curr, ")"), context).addClass('active');
            $(".carousel-full-width .image-area .images .image:nth-child(".concat(curr, ")"), context).addClass('active');
            $(".carousel-full-width .next-image-wrapper .image:nth-child(".concat(next, ")"), context).addClass('active');
          }
          var interval = setInterval(nextCarousel, 6000);
          $('.carousel-full-width .controls .prev', context).click(function () {
            prevCarousel();
            clearInterval(interval);
          });
          $('.carousel-full-width .controls .next', context).click(function () {
            nextCarousel();
            clearInterval(interval);
          });
        };
        console.log('CarouselMain initialized');
        setTimeout(function () {
          carousel();
        }, 1000);
      }
    }
  };
})(jQuery, Drupal, once);